import { render, staticRenderFns } from "./Aspek.vue?vue&type=template&id=1ebc902c&"
import script from "./Aspek.vue?vue&type=script&lang=js&"
export * from "./Aspek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports